import { render, staticRenderFns } from "./AsideCommon.vue?vue&type=template&id=5f70a646&scoped=true"
import script from "./AsideCommon.vue?vue&type=script&lang=js"
export * from "./AsideCommon.vue?vue&type=script&lang=js"
import style0 from "./AsideCommon.vue?vue&type=style&index=0&id=5f70a646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f70a646",
  null
  
)

export default component.exports